// Creates a handler from the given function
export function handler(handle) {
  return { handle };
}
